
import { supabase } from "@/lib/supabase";
import { DBMessage } from "@/types/message";
import { convertToDBMessage } from "./types";

export async function fetchMessages(refundRequestId: string): Promise<DBMessage[]> {
  const { data, error } = await supabase
    .from("messages")
    .select("*")
    .eq("refund_request_id", refundRequestId)
    .order("created_at", { ascending: true });
  
  if (error) throw error;
  
  return (data || []).map(convertToDBMessage);
}
